import { SyntheticEvent } from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { TagLink } from 'styles-js/buttons';
type Props = {
  tags: {
    entityName?: string;
    entityId?: number;
    id?: number;
    name?: string;
    shortName?: string;
    slug: string;
  }[];
  onClick?: (slug: string, id: number) => void;
};
export default function HealthTags({
  tags,
  onClick
}: Props) {
  if (tags.length === 0) return null;
  const onTagClick = (e: SyntheticEvent, slug: string, id?: number) => {
    if (onClick && id) onClick(slug, id);
  };
  return <List data-sentry-element="List" data-sentry-component="HealthTags" data-sentry-source-file="healthTags.tsx">
      {tags.map(tag => {
      const tagName = tag.name || tag.shortName || tag.entityName;
      return <li key={tag.slug}>
            <Link legacyBehavior passHref as={`/tag/${tag.slug}`} href={`/tag?slug=${tag.slug}`}>
              <TagLink data-testid="button-tag" onClick={(e: SyntheticEvent) => onTagClick(e, tag.slug, tag.entityId || tag.id)}>
                {tagName}
              </TagLink>
            </Link>
          </li>;
    })}
    </List>;
}
const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: inline-block;
  }
`;